import { apiService, ApiResponse } from './api.service';

export interface SubscriptionPlan {
  id: string;
  customerTypeId: string;
  tenantId: string;
  name: string;
  description: string | null;
  price: string | null;
  defaultFrequency: 'MONTHLY' | 'QUARTERLY' | 'ANNUALLY' | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  customerType?: { id: string; name: string; isSubscriptionBased: boolean };
  _count?: { customers: number };
}

export interface CreateSubscriptionPlanDto {
  name: string;
  description?: string;
  price?: number;
  defaultFrequency?: 'MONTHLY' | 'QUARTERLY' | 'ANNUALLY';
  isActive?: boolean;
}

export interface UpdateSubscriptionPlanDto {
  name?: string;
  description?: string;
  price?: number;
  isActive?: boolean;
}

class SubscriptionPlansService {
  async getAll(): Promise<ApiResponse<SubscriptionPlan[]>> {
    return apiService.get<SubscriptionPlan[]>('/customer-types/plans');
  }

  async getByTypeId(customerTypeId: string): Promise<ApiResponse<SubscriptionPlan[]>> {
    return apiService.get<SubscriptionPlan[]>(`/customer-types/${customerTypeId}/plans`);
  }

  async create(customerTypeId: string, data: CreateSubscriptionPlanDto): Promise<ApiResponse<SubscriptionPlan>> {
    return apiService.post<SubscriptionPlan>(`/customer-types/${customerTypeId}/plans`, data);
  }

  async update(id: string, data: UpdateSubscriptionPlanDto): Promise<ApiResponse<SubscriptionPlan>> {
    return apiService.patch<SubscriptionPlan>(`/customer-types/plans/${id}`, data);
  }

  async remove(id: string): Promise<ApiResponse<{ message: string }>> {
    return apiService.delete<{ message: string }>(`/customer-types/plans/${id}`);
  }
}

export const subscriptionPlansService = new SubscriptionPlansService();
